export const EVM_WALLET_LOGOS: Record<string, string> = {
  safe: "https://raw.githubusercontent.com/rainbow-me/rainbowkit/6b460fcba954e155828e03f46228ee88a171a83b/packages/rainbowkit/src/wallets/walletConnectors/safeWallet/safeWallet.svg",
  walletConnect:
    "https://raw.githubusercontent.com/rainbow-me/rainbowkit/6b460fcba954e155828e03f46228ee88a171a83b/packages/rainbowkit/src/wallets/walletConnectors/walletConnectWallet/walletConnectWallet.svg",
  coinbaseWallet:
    "https://raw.githubusercontent.com/rainbow-me/rainbowkit/6b460fcba954e155828e03f46228ee88a171a83b/packages/rainbowkit/src/wallets/walletConnectors/coinbaseWallet/coinbaseWallet.svg",
  metaMask: "/metamask-logo.svg",
  injected:
    "https://raw.githubusercontent.com/rainbow-me/rainbowkit/6b460fcba954e155828e03f46228ee88a171a83b/packages/rainbowkit/src/wallets/walletConnectors/injectedWallet/injectedWallet.svg",
};
